import {
  FoodControlPointInstanceDto,
  FoodManagementControls,
} from "@enos-monorepo/lib";

import { AddPestsRevisionControlModal } from "./Modals/AddPestsRevisionControlModal";
import { AddPestsRoundingControlModal } from "./Modals/AddPestsRoundingControlModal";
import { CleaningFloorAndHoodModal } from "./Modals/CleaningFloorAndHoodModal";
import { DishWasherControlModal } from "./Modals/DishwasherControlModal";
import { FermentedVegetableModal } from "./Modals/FermentedVegetableModal";
import { FoodAcceptanceModal } from "./Modals/FoodAcceptanceModal";
import { FreezingFishControlModal } from "./Modals/FreezingFishControlModal";
import { HeatModal } from "./Modals/HeatModal";
import { InventoryControlsModal } from "./Modals/InventoryControlsModal";
import { OpenBuffetControlModal } from "./Modals/OpenBuffetControlModal";
import { PicklesPhControlModal } from "./Modals/PicklesPhControlModal";
import { PreservationModal } from "./Modals/PreservationModal";
import { RefrigerationModal } from "./Modals/RefrigerationModal";
import { RevisionModal } from "./Modals/RevisionModal";
import { SushiRicePhControlModal } from "./Modals/SushiRicePhControlModal";
import { ThermometerVerificationModal } from "./Modals/ThermometerVerificationModal";
import { YearlyMaintenanceModal } from "./Modals/YearlyMaintenanceModal";

interface ControlPointModalsProps {
  modalOpen: Record<FoodManagementControls, boolean>;
  closeModals: () => void;
  currentInstance?: FoodControlPointInstanceDto;
}

export function ControlPointModals({
  modalOpen,
  closeModals,
  currentInstance,
}: ControlPointModalsProps) {
  if (!currentInstance) return null;
  return (
    <>
      <RefrigerationModal
        open={modalOpen.coolingFood}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <InventoryControlsModal
        open={modalOpen.freezer}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
        type={FoodManagementControls.freezer}
        title={currentInstance?.controlPoint?.name}
      />
      <InventoryControlsModal
        open={modalOpen.cooler}
        onClose={closeModals}
        type={FoodManagementControls.cooler}
        foodControlPointInstance={currentInstance}
        title={currentInstance?.controlPoint?.name}
      />
      <InventoryControlsModal
        open={modalOpen.fishCooler}
        onClose={closeModals}
        type={FoodManagementControls.fishCooler}
        foodControlPointInstance={currentInstance}
        title={currentInstance?.controlPoint?.name}
      />
      <HeatModal
        open={modalOpen.heatingTreatment}
        type={FoodManagementControls.heatingTreatment}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <HeatModal
        open={modalOpen.reheatingFood}
        type={FoodManagementControls.reheatingFood}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <AddPestsRoundingControlModal
        open={modalOpen.pestsRouding}
        type={FoodManagementControls.pestsRouding}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <AddPestsRevisionControlModal
        open={modalOpen.pestsRevision}
        type={FoodManagementControls.pestsRevision}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <RevisionModal
        open={modalOpen.revisionOfControls}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <CleaningFloorAndHoodModal
        open={modalOpen.cleaningFloor}
        type={FoodManagementControls.cleaningFloor}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <CleaningFloorAndHoodModal
        open={modalOpen.cleaningHood}
        type={FoodManagementControls.cleaningHood}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <ThermometerVerificationModal
        open={modalOpen.thermometerVerification}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <PreservationModal
        open={modalOpen.heatRetention}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <YearlyMaintenanceModal
        open={modalOpen.maintenanceExamination}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <DishWasherControlModal
        open={modalOpen.cleaningDishwasher}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <FoodAcceptanceModal
        open={modalOpen.goodsReceipt}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <FreezingFishControlModal
        open={modalOpen.freezingfish}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <SushiRicePhControlModal
        open={modalOpen.sushiricepH}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <OpenBuffetControlModal
        open={modalOpen.openbuffet}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <FermentedVegetableModal
        open={modalOpen.vegetablespHbeginning}
        type={FoodManagementControls.vegetablespHbeginning}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <FermentedVegetableModal
        open={modalOpen.vegetablespH48Hours}
        type={FoodManagementControls.vegetablespH48Hours}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <FermentedVegetableModal
        open={modalOpen.vegetablespHfinal}
        type={FoodManagementControls.vegetablespHfinal}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <PicklesPhControlModal
        open={modalOpen.picklespH}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
    </>
  );
}
